import { useFlags } from 'launchdarkly-react-client-sdk';

import OldNoteEdit from './noteEdit';
import NewNoteEdit from './newNoteEdit';
import { Props } from './newNoteEdit';

export const NoteEdit = (props: Props) => {
  const { enableBillingUpdates } = useFlags();

  return enableBillingUpdates ? <NewNoteEdit {...props} /> : <OldNoteEdit {...props} />;
};
